module.exports = __webpack_public_path__ + "img/huaxiayh.353793ac.png";